// @ts-check
import { decamelizeKeys } from 'humps';
import React, { Component } from 'react';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import LoadingContent from 'shared/components/LoadingContent';
import QuestionnaireTemplateEditor from 'shared/components/QuestionnaireTemplateEditor';
import api from 'utils/api';

/** @typedef {{
  specialtyId: string,
  organizationId: string,
  apiPrefix: string
}} OrganizationQuestionnaireTemplateEditorProps */

/** @typedef {{
  sections: any,
  referralProfileRulableFields: any,
  errorCollection: any
}} OrganizationQuestionnaireTemplateEditorState
*/

/** @augments { Component<OrganizationQuestionnaireTemplateEditorProps, OrganizationQuestionnaireTemplateEditorState> } */
class OrganizationQuestionnaireTemplateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sections: null,
      referralProfileRulableFields: null,
      errorCollection: null,
    };
  }

  componentDidMount() {
    // prettier-ignore
    const path = `${this.props.apiPrefix}/organizations/${this.props.organizationId}/specialties/${this.props.specialtyId}/organization_specialty_configuration/questionnaire_template/edit`;
    api.get(path).then(response => {
      this.setState({
        sections: response.data.sections,
        referralProfileRulableFields: response.data.referralProfileRulableFields,
      });
    });
  }

  save = () => {
    // prettier-ignore
    const path = `${this.props.apiPrefix}/organizations/${this.props.organizationId}/specialties/${this.props.specialtyId}/organization_specialty_configuration/questionnaire_template`;
    api
      .putWithoutDefaultRejectionHandling(path, {
        questionnaire_template: { sections: decamelizeKeys(this.state.sections) },
      })
      .then(
        () => {
          this.setState({ errorCollection: null });
          FlashMessageActions.flashSuccess({ message: 'Successfully saved form' });
        },
        error => {
          if (error.response && error.response.data && error.response.data.errorCollection) {
            this.setState({ errorCollection: error.response.data.errorCollection });
            FlashMessageActions.flashError({
              message: 'Please double-check the questionnaire template for errors.',
            });
            throw error;
          } else {
            return error.defaultRejectionHandler(error);
          }
        }
      );
  };

  onChangeSections = sections => {
    this.setState({ sections: sections });
  };

  render() {
    if (!this.state.sections) return <LoadingContent />;
    return (
      <div>
        <QuestionnaireTemplateEditor
          errorCollection={this.state.errorCollection}
          sections={this.state.sections}
          onChange={this.onChangeSections}
          referralProfileRulableFields={this.state.referralProfileRulableFields}
        />
        <div className="form-actions">
          <button
            id="bottom-add-section"
            type="button"
            className="btn btn-primary"
            onClick={this.save}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

export default OrganizationQuestionnaireTemplateEditor;
